(() => {
  const config = window.RehabiRecurrente || {};
  const workerBase = String(config.workerBase || "").replace(/\/$/, "");
  const checkoutSelectors = config.selectors || ["#Recurrente-Cart-Checkout", "#Recurrente-Checkout", "[data-recurrente-checkout]"];
  let active = false;

  document.addEventListener("click", async (event) => {
    const buyNow = event.target.closest("[data-recurrente-buy-now]");
    const cartCheckout = checkoutSelectors.map((selector) => event.target.closest(selector)).find(Boolean);
    const button = buyNow || cartCheckout;
    if (!button || active || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    if (!workerBase) return showError(button, "El pago todavía no está configurado.");

    active = true;
    const labelNode = button.querySelector(".button-text") || button;
    const label = labelNode.textContent;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    labelNode.textContent = "Preparando pago…";

    try {
      const items = buyNow ? readProductSelection(button) : await readCartItems();
      await beginCheckout(items);
    } catch (error) {
      showError(button, error.message || "No pudimos iniciar el pago.");
      button.disabled = false;
      button.removeAttribute("aria-busy");
      labelNode.textContent = label;
      active = false;
    }
  }, true);

  document.addEventListener("shopify:cart:lines-update", (event) => {
    const completion = event.promise;
    if (completion && typeof completion.then === "function") {
      completion.then(refreshCartCount).catch(() => refreshCartCount());
    } else {
      refreshCartCount();
    }
  });
  document.addEventListener("shopify:cart:update", refreshCartCount);
  window.addEventListener("pageshow", refreshCartCount);

  if (new URLSearchParams(location.search).get("clear_cart") === "1") {
    fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" }).then(refreshCartCount).catch(() => {});
  } else {
    refreshCartCount();
  }

  async function beginCheckout(items) {
    if (!items.length) throw new Error("Tu carrito está vacío.");
    const payload = {
      cart_token: await readCartToken(),
      items,
      customer: readCustomer(),
      shipping_address: readShipping(),
      note: readValue("[name='note'], #Cart-note, #CartDrawer-Note"),
      success_url: `${location.origin}/pages/gracias`,
      cancel_url: location.href,
    };
    const response = await fetch(`${workerBase}/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.checkout_url) {
      if (response.status === 409) throw new Error("Este producto cambió de disponibilidad. Actualiza la página e inténtalo de nuevo.");
      throw new Error(data.message || "No pudimos iniciar el pago. Inténtalo nuevamente.");
    }
    location.assign(data.checkout_url);
  }

  function readProductSelection(button) {
    const form = button.closest("form") || button.closest("product-form-component")?.querySelector("form");
    const variantId = form?.querySelector('[name="id"]')?.value;
    const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
    if (!variantId) throw new Error("Selecciona una variante disponible.");
    return [{ variant_id: variantId, quantity: Number.isInteger(quantity) && quantity > 0 ? quantity : 1 }];
  }

  async function readCart() {
    const response = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("No pudimos leer tu carrito.");
    return response.json();
  }
  async function readCartItems() {
    const cart = await readCart();
    return (cart.items || []).map((item) => ({ variant_id: item.variant_id, quantity: item.quantity }));
  }
  async function readCartToken() {
    try { return (await readCart()).token || ""; } catch { return ""; }
  }
  async function refreshCartCount() {
    try {
      const cart = await readCart();
      const count = Number(cart.item_count || 0);
      document.querySelectorAll(".rc-header__cart-count").forEach((node) => {
        node.textContent = String(count);
        node.hidden = count < 1;
      });
      document.querySelectorAll(".rc-header__cart").forEach((link) => {
        link.setAttribute("aria-label", `Carrito, ${count} ${count === 1 ? "artículo" : "artículos"}`);
      });
    } catch {}
  }
  function readValue(selector) { return document.querySelector(selector)?.value?.trim() || ""; }
  function readCustomer() {
    const fullName = readValue("[data-recurrente-name], #rm-full-name, #rm-cart-full-name");
    const parts = fullName.split(/\s+/).filter(Boolean);
    return { email: readValue("[data-recurrente-email], #rm-email, #rm-cart-email"), phone: readValue("[data-recurrente-phone], #rm-phone, #rm-cart-phone"), first_name: parts.shift() || "", last_name: parts.join(" ") };
  }
  function readShipping() {
    return { address1: readValue("[data-recurrente-address], #rm-address, #rm-cart-address"), city: readValue("[data-recurrente-city], #rm-location, #rm-cart-location"), zip: readValue("[data-recurrente-zip]") };
  }
  function showError(button, message) {
    let node = button.parentElement?.querySelector("[data-recurrente-error]");
    if (!node) {
      node = document.createElement("p");
      node.dataset.recurrenteError = "";
      node.setAttribute("role", "alert");
      node.style.cssText = "margin:12px 0 0;color:#a33;font-size:13px;line-height:1.4";
      button.insertAdjacentElement("afterend", node);
    }
    node.style.display = "block";
    node.textContent = message;
  }
})();
